import __regexp from './__yandex-regexp';
/** Detect Yandex Browser */
export default function isYandex(ua) {
	return __regexp.test(ua);
}
